import {useQuery} from '@tanstack/react-query'
import {apiClient} from '../../lib/apiClient'
import type {ApiResponse} from '../../types'
export function usePublicSettings() {
 return useQuery({queryKey:['public-settings'],queryFn:async()=>(await apiClient.get<ApiResponse<Record<string,string>>>('/public/settings')).data.data})
}
